import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroupFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 18C3 15.791 4.791 14 7 14H11C13.209 14 15 15.791 15 18H3Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 4.99613C12.8282 6.3243 12.8282 8.67183 11.5 10C10.1718 11.3282 7.82817 11.3282 6.5 10C5.17183 8.67183 5.17183 6.3243 6.5 4.99613C7.82817 3.66796 10.1718 3.66796 11.5 4.99613Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 4.5C17.381 4.5 18.5 5.619 18.5 7C18.5 8.381 17.381 9.5 16 9.5M17 13C19.209 13 21 14.791 21 17M3 18C3 15.791 4.791 14 7 14H11C13.209 14 15 15.791 15 18H3ZM11.5 4.99613C12.8282 6.3243 12.8282 8.67183 11.5 10C10.1718 11.3282 7.82817 11.3282 6.5 10C5.17183 8.67183 5.17183 6.3243 6.5 4.99613C7.82817 3.66796 10.1718 3.66796 11.5 4.99613Z",
			stroke: "#111827",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgGroupFilled);
export default ForwardRef;
